import type {
  ConsultaPermissao,
  ContextoAcesso,
  FeatureFlag,
  TipoUsuario,
} from './acesso.tipos'

export const temPermissao = (
  contexto: ContextoAcesso,
  consulta: ConsultaPermissao,
): boolean => {
  if ('modulo' in consulta) {
    return contexto.permissoes.some((permissao) => (
      permissao.modulo === consulta.modulo
      && permissao.acao === consulta.acao
      && (consulta.filtros === undefined || consulta.filtros.includes(permissao.filtro ?? ''))
    ))
  }

  const nomes = new Set(contexto.permissoes.map(({ nome }) => nome))
  if ('any' in consulta) {
    return consulta.any.some((nome) => nomes.has(nome))
  }

  return consulta.multiple.length > 0
    && consulta.multiple.every((nome) => nomes.has(nome))
}

export const usuarioTemEscopo = (
  contexto: ContextoAcesso,
  escopos: TipoUsuario | readonly TipoUsuario[],
): boolean => {
  const tipo = contexto.usuario?.tipo
  return tipo !== undefined && (Array.isArray(escopos)
    ? escopos.includes(tipo)
    : tipo === escopos)
}

export const usuarioEhRh = (contexto: ContextoAcesso): boolean => usuarioTemEscopo(contexto, 'all')

export const usuarioEhGestor = (contexto: ContextoAcesso): boolean => usuarioTemEscopo(contexto, 'group')

export const usuarioEhColaborador = (contexto: ContextoAcesso): boolean => usuarioTemEscopo(contexto, 'mine')

export const temModulo = (contexto: ContextoAcesso, slug: string): boolean | undefined => (
  contexto.disponibilidade.modulos[slug]
)

export const obterFuncionalidade = (
  contexto: ContextoAcesso,
  slug: string,
): FeatureFlag | undefined => {
  const origem = contexto.disponibilidade.origensFuncionalidades[slug]
  if (origem === 'flagsmith') {
    return contexto.disponibilidade.funcionalidades[slug]
  }
  if (origem === 'legado') {
    return contexto.disponibilidade.funcionalidadesLegadas[slug]
  }
  return undefined
}

export const temFuncionalidade = (
  contexto: ContextoAcesso,
  slug: string,
): boolean | undefined => obterFuncionalidade(contexto, slug)?.habilitada
